import { createSvgEl } from '@learnforge/demo-render';
import type { Point } from '../finance/series';
import type { ChartHandle } from './chart';

export interface LineSeriesHandle {
  setSeries(id: string, points: readonly Point[], className: string): void;
  clear(id: string): void;
  destroy(): void;
}

export function createLineSeries(chart: ChartHandle): LineSeriesHandle {
  const paths = new Map<string, SVGPathElement>();

  function buildD(points: readonly Point[]): string {
    if (points.length === 0) return '';
    const { x: x0, y: y0 } = chart.toScreen(points[0]!);
    const parts = [`M ${x0} ${y0}`];
    for (let i = 1; i < points.length; i++) {
      const { x, y } = chart.toScreen(points[i]!);
      parts.push(`L ${x} ${y}`);
    }
    return parts.join(' ');
  }

  function setSeries(id: string, points: readonly Point[], className: string): void {
    let path = paths.get(id);
    if (!path) {
      path = createSvgEl('path', { fill: 'none' });
      chart.plotGroup.appendChild(path);
      paths.set(id, path);
    }
    path.setAttribute('d', buildD(points));
    path.setAttribute('class', className);
  }

  function clear(id: string): void {
    const path = paths.get(id);
    if (path) {
      path.parentNode?.removeChild(path);
      paths.delete(id);
    }
  }

  function destroy(): void {
    for (const path of paths.values()) {
      path.parentNode?.removeChild(path);
    }
    paths.clear();
  }

  return { setSeries, clear, destroy };
}
